import {FC} from 'react';
import {RegistrationCountry} from '../../../model';
import {FlagOrb} from './FlagOrb/FlagOrb';

type Props = {
	country?: RegistrationCountry;
	className?: string;
};

export const CountryFlag: FC<Props> = ({country, className}) => {
	return <FlagOrb placeholder="union" tone="muted" className={className} />;
};
